import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import clientSignupReducer, { initialState } from '../reducers/clientSignupReducer';

export const ClientSignupContext = createContext();

const ClientSignupProvider = ({ children }) => {
  const useStatesState = useReducer(clientSignupReducer, initialState);

  return (
    <ClientSignupContext.Provider value={[...useStatesState]}>
      <ContextDevTool
        context={ClientSignupContext}
        id="ClientSignupContext"
        displayName="Client Signup Context"
      />
      {children}
    </ClientSignupContext.Provider>
  );
};

ClientSignupProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ClientSignupProvider;
